import { ArrowRight } from "lucide-react";
import { goToWaitlist } from "@/lib/site";
import { Reveal } from "./Reveal";
import { WordmarkLockup } from "./Wordmark";

export const Sunset = () => (
  <section id="sunset" data-testid="section-sunset" aria-label="Because their tomorrow is built on your today" className="relative overflow-hidden">
    <img
      src="/assets/sunset_girl_v2.jpg"
      alt="A young woman sitting on a hilltop at dusk, looking out over the glowing city lights"
      data-testid="sunset-image"
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover object-[74%_60%]"
    />
    <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-[#030507]/90 via-[#030507]/35 to-transparent" />
    <div className="pointer-events-none absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-[#030507] to-transparent" />
    <div className="pointer-events-none absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#030507] to-transparent" />

    <div className="cl-container relative flex min-h-[700px] flex-col justify-between gap-16 py-24 sm:min-h-[640px] lg:min-h-[720px] lg:py-28">
      <Reveal className="max-w-md">
        <p className="cl-kicker">THE FUTURE OF FAMILY</p>
        <h2 data-testid="sunset-heading" className="cl-heading mt-5 text-[2.2rem] leading-[1.1] sm:text-5xl">
          <span className="block text-white">Because their tomorrow is built</span>
          <span className="block text-[#E7C99D]">on your today.</span>
        </h2>
        <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-[#C9D3DE]">
          Chronoloop doesn't just store your memories. It brings them to life — so your family can feel, see, hear and
          experience your story.
        </p>
        <a href="#launching-soon" onClick={goToWaitlist} data-testid="sunset-start-journey-button" className="btn-gold mt-9">
          Start Your Journey <ArrowRight size={16} strokeWidth={1.4} />
        </a>
        <p className="mt-8 text-[10px] font-medium tracking-[0.34em] text-[#E7C99D]">SAME ROOTS. BRIGHTER HORIZONS.</p>
      </Reveal>
      <div className="self-end">
        <WordmarkLockup testid="sunset-wordmark" className="text-xl sm:text-2xl" taglineClass="text-[8px] sm:text-[9px]" />
      </div>
    </div>
  </section>
);
